import {Action, NgxsOnInit, Selector, State, StateContext, StateToken, Store} from '@ngxs/store';
import {Injectable} from "@angular/core";
import {DismissToast, SendClickableToast, SendToast} from "../actions/toast.actions";
import {ToastrHelper} from "../helper/toaster.helper";
import {SystemNotification} from "../models/system-notifications.model";


export interface ToastStateModel {
  messages: SystemNotification[];
}

const TOAST_STATE_TOKEN = new StateToken<ToastStateModel>('toasts');

@State<ToastStateModel>({
  name: TOAST_STATE_TOKEN,
  defaults: {
    messages: []
  },
})

@Injectable()
export class ToastState implements NgxsOnInit {

  constructor(private store: Store, private toastrHelper:ToastrHelper) {
  }

  // load on store init
  ngxsOnInit(ctx: StateContext<ToastStateModel>) {
    ctx.dispatch(
      []
    );
  }

  @Selector()
  static getToastList(state: ToastStateModel) {
    const newMsgOrder = state?.messages;
    return newMsgOrder.slice().sort((a, b) => b.timestamp - a.timestamp);
  }

  // send message
  @Action(SendToast)
  sendToast(ctx: StateContext<ToastStateModel>, action: SendToast) {
    const state = ctx.getState();
    ctx.patchState({
      messages: [
        ...state?.messages,
        action.message
      ]
    });
    this.toastrHelper.showToast(action.message);
  }

  // send message
  @Action(SendClickableToast)
  sendClickableToast(ctx: StateContext<ToastStateModel>, action: SendToast) {
    const state = ctx.getState();
    ctx.patchState({
      messages: [
        ...state.messages,
        action.message
      ]
    });
    this.toastrHelper.showToast(action.message);
  }

  @Action(DismissToast)
  dismissToast(ctx: StateContext<ToastStateModel>, action: DismissToast) {
    const state = ctx.getState();
    let x = state?.messages.slice().splice(action.index, 1);
    ctx.patchState({
      messages:
        [...state.messages.slice(1)]
    });
  }

}
